import { render, staticRenderFns } from "./IntakeListHeadFilter.vue?vue&type=template&id=71d0989e&"
import script from "./IntakeListHeadFilter.vue?vue&type=script&lang=js&"
export * from "./IntakeListHeadFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports